/* eslint-disable no-console */
import { useEffect } from 'react';
import { isCmRepo } from './gitStreamIntegration/gitStream.service';
import {
  REPOSITORIES_STATE,
  SESSION_STORAGE_KEYS
} from 'common/constants/constants';
import { updateRepository, getSensorAuthorizations } from 'state/callers';
import { useDispatch } from 'react-redux';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';

const useUpdateCmRepo = ({ repositories }) => {
  const dispatch = useDispatch();

  const gitstreamSensorAuthId = BrowserStorageAccessor().session.get(
    SESSION_STORAGE_KEYS.UPDATE_GITSTREAM_ON_INTEGRATION_ID
  );

  const updateCmRepo = async () => {
    const cmRepo = repositories.find(
      repo =>
        repo.sensor_authorization_id === Number(gitstreamSensorAuthId) &&
        isCmRepo(repo?.name)
    );

    if (cmRepo && !cmRepo?.extra?.is_gitstream_enabled) {
      await updateRepository(cmRepo.id, {
        state: REPOSITORIES_STATE.ACTIVE, // enable cm repo for linearB
        extra: { is_gitstream_enabled: true }
      })(dispatch);
      await getSensorAuthorizations({ withGitStreamEnabled: true })(dispatch);
      BrowserStorageAccessor().session.remove(
        SESSION_STORAGE_KEYS.UPDATE_GITSTREAM_ON_INTEGRATION_ID
      );
    }
  };

  useEffect(() => {
    if (!gitstreamSensorAuthId) {
      return;
    }
    updateCmRepo();
  }, [repositories, gitstreamSensorAuthId]);
};

export default useUpdateCmRepo;
